import { Camera, UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { useMemo, useState } from 'react';
import { CameraDetails } from '../types';
import { getDetailsMapping } from '../utils';

export function useAlarmState(
  alarms: UnifiedAlarm[],
  neighbourAlarms: UnifiedAlarm[]
) {
  // Create the camera to details mapping
  const { camToDetailsMap, alarmToDetailsMap } = useMemo(() => {
    return getDetailsMapping([...alarms, ...neighbourAlarms]);
  }, [alarms, neighbourAlarms]);

  // State for extra cameras
  const [extraCamDetailsMap, setExtraCamDetailsMap] = useState<
    Record<string, CameraDetails>
  >({});

  // Extract alarm camera IDs
  const alarmCameraIds = useMemo(() => {
    return Object.keys(camToDetailsMap);
  }, [camToDetailsMap]);

  // Handler for updating extra cameras from tenant
  const updateExtraCamFromTenant = (cams: Camera[]) => {
    const extraCamFromTenantMap: Record<string, CameraDetails> = {};
    cams.forEach((cam) => {
      extraCamFromTenantMap[cam.id] = {
        alarms: [],
        cameraGroupId: cam.cameraGroupId ?? '',
        cameraGroupName: cam.cameraGroupName ?? '',
        cameraId: cam.id,
        cameraLiveStreamUrl: cam.livestreamUrl ?? '',
        cameraName: cam.name ?? '',
        cameraPlayBackUrl: cam.visionPlaybackUrl ?? '',
        isAlarmVideoDisabled: true,
        isTalkdownEnabled: !!(cam.audioDevices && cam.audioDevices.length > 0),
      };
    });
    setExtraCamDetailsMap(extraCamFromTenantMap);
  };

  // List of additional camera IDs from tenant
  const tenantAdditionalCameraIds = useMemo(
    () => Object.keys(extraCamDetailsMap),
    [extraCamDetailsMap]
  );

  return {
    camToDetailsMap,
    extraCamDetailsMap,
    updateExtraCamFromTenant,
    alarmCameraIds,
    tenantAdditionalCameraIds,
    alarmToDetailsMap,
  };
}
